import { Component,NgZone, OnInit,ViewChild, PLATFORM_ID, Inject, Input, Output, EventEmitter, OnChanges, ElementRef,HostListener } from '@angular/core';
import { FormBuilder,FormGroup,FormControl,Validators,NgForm } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import {commonService} from "../../service/common.service";
import { sessionService } from '../../service/session.service';
import { HttpErrorResponse } from '@angular/common/http';
import { userService } from '../../service/user.service';
import {Globals } from '../../globals';
import { jobService } from '../../service/job.service';

@Component({
  selector: 'app-vjobfulllist',
  templateUrl: './vjobfulllist.component.html',
  styleUrls: ['./vjobfulllist.component.css'],
  providers: [sessionService,userService,jobService],
})
export class VjobfulllistComponent implements OnInit {
  jobType:any;
  listValue:any;  
  isError=false;
  msg:any;
  dynamicType:String='';
  accounts:any;
  isPostLoad=true;


  constructor(private jobFull:jobService,public router: Router,private frmBuilder: FormBuilder,private commonService:commonService,private _session:sessionService,private route: ActivatedRoute,
    private global: Globals) {}  

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
    
      if(params['jobType']){
        this.jobType = params['jobType'];
        this.jobFull.jobfulllist(this.jobType).subscribe((data : any)=>{
         if(data.error==0){
           this.isPostLoad=false;
           this.dynamicType = data.results.rows[0].jobType;    
           this.listValue = data.results.rows;

      }else{
          if(data.message=="Failed to authenticate token."){
            sessionStorage.clear();
            localStorage.clear();
            this.router.navigate(['/']);
          }else{
           this.msg = data.message;
           this.isError = true;
          }
        }
      },
      (error : HttpErrorResponse)=>{
      this.isError = true;
      this.msg="internal server error!";
      });  
    }
  }) 
  }

  detailpg(Id){
    let encodeUrl:any;   
    encodeUrl="cid="+Id;
    encodeUrl=encodeURIComponent(encodeUrl);  
    this.router.navigateByUrl('/jobdetail?searchparam='+btoa(encodeUrl));
  }

  ascList(listValue){     
    this.listValue = listValue;
    this.listValue.reverse();
   }

}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/vjobfulllist/vjobfulllist.component.ts